import { MessageSchema } from "@redotech/redo-agents-common/llm-messages";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getAiChats = {
  name: "getAiChats" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ chatHistory: MessageSchema.array() }),
};
